const blockstyle = {
  field_block_style: {
    name: "Default",
    tid: "19",
    attributes: {
      field_background_options: "one",
      field_color_1: "#fff",
      field_title_color_font: [
        {
          item_id: "57",
          revision_id: "1131",
          field_name: "field_title_color_font",
          default_revision: "1",
          bundle: "text_color_and_font",
          field_color_1: "#101418",
          field_font_1: {
            name: "Oswald",
            tid: "14"
          },
          field_bgcolor_1: "#b2d23e"
        }
      ],
      field_heading_color_font: [
        {
          item_id: "58",
          revision_id: "1132",
          field_name: "field_heading_color_font",
          default_revision: "1",
          bundle: "text_color_and_font",
          field_color_1: "#000",
          field_font_1: {
            name: "Oswald",
            tid: "14"
          },
          field_bgcolor_1: "#fff"
        }
      ],
      field_text_color_font: [
        {
          item_id: "59",
          revision_id: "1133",
          field_name: "field_text_color_font",
          default_revision: "1",
          bundle: "text_color_and_font",
          field_color_1: "#000",
          field_font_1: {
            name: "Oswald",
            tid: "14"
          },
          field_bgcolor_1: "transparent"
        }
      ],
      field_link_colors: {
        name: "blackUGreenHighlight",
        tid: "48"
      },
      field_button_style: {
        name: "GreenButtonWithArrow",
        tid: "29",
        attributes: {
          field_boolean_1: "1"
        }
      }
    }
  }
};

export default blockstyle;
